import { Shadow } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { CustomerTableProps } from '../models';
import { TableItemList } from '../TableItemList';
import { ResponsiveLoadingTable } from '../TableItemList/components/LoadingTable';

export const CustomerTabletTable: React.FC<CustomerTableProps> = (props) => {
  return (
    <Box px={Spacing['inline.xxs']} overflow={'hidden'}>
      <Shadow
        level={2}
        borderRadius={BoxRadius.sm}
        testId="customer-table-list"
        mb={Spacing['inset.md']}>
        {props.isLoading && <ResponsiveLoadingTable />}
        {!props.isLoading && <TableItemList {...props} />}
      </Shadow>
    </Box>
  );
};
